import { FC } from 'react'
import s from './LookAlso.module.sass'
import { Template } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/Template'
import { TemplateCardProps } from '@widgets/Restaurant/RestCards/RestCard/type/TemplateCardProps'
import TypeAndPrice from '@widgets/Restaurant/RestCards/RestCard/ui/Components/TypeAndPrice/TypeAndPrice'
import { Place } from '@widgets/Restaurant/RestCards/RestCard/ui/Components/Place'
import { ScheduleAndPrice } from '@widgets/Restaurant/RestCards/RestCard/ui/Components/ScheduleAndPrice'
import { useCurrentSize } from '@shared/lib/helpers/classes'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { PromoBadgeLabel } from '@shared/ui/Feedback/PromoBadges/PromoBadgeLabel'

const LookAlso: FC<
  TemplateCardProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = (props) => {
  const [size] = useCurrentSize(props.sizes)

  const price = props.data.price
  const address = props.data.address.address
  const metro = props.data.address.metro
  return (
    <BlockBoundary>
      <Template {...props}>
        {!!props.data.discounts.remarked && (
          <PromoBadgeLabel label={'Скидка'} className={s['promo-label']}>
            -{props.data.discounts.remarked}₽
          </PromoBadgeLabel>
        )}

        {!!props.data.discounts.restoplace && (
          <PromoBadgeLabel label={'Скидка'} className={s['promo-label']}>
            -{props.data.discounts.restoplace}₽
          </PromoBadgeLabel>
        )}

        {/*<TastyClub tastyClub={props.data.discounts.tastyclub} />*/}

        <TypeAndPrice
          restType={props.data.type}
          priceRange={size !== 'S' ? price.level : null}
          priceLink={price.tag.url}
        />
        {size !== 'S' && <Place address={address} metro={metro} />}

        <ScheduleAndPrice
          schedule={props.data.schedule}
          priceRange={size === 'S' ? price.level : null}
          priceLink={price.tag.url}
        />
        {size === 'S' && <Place address={address} metro={metro} />}
      </Template>
    </BlockBoundary>
  )
}

export default LookAlso
